import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Component from 'decorators/Component'
import { colors, marginSizes } from 'theme/default'
import Div from 'components/Div'
import Flex from 'components/Flex'
import Modal, { PrevButton, CloseButton } from 'components/Modal'
import { H4, P } from 'components/Typo'
import Form, { FormContext } from 'components/Form'
import Divider from 'components/Divider'

const LineThroughText = styled(P).attrs(() => ({
  marginLeft: 'small'
}))`
  text-decoration: line-through;
  color: ${colors.brandPrimary};
`

const PromotionItemForm = Component()(({
  t,
  promotionItems = [],
  promotionQuantity,
  onPromotionItemSubmit = () => {},
  onPrevButtonClick = () => {},
  onCloseButtonClick = () => {},
  formatMoney = x => x
}) => {
  return (
    <Form onSubmit={onPromotionItemSubmit}>
      <FormContext>
        {({ values, isSubmitting }) => {
          const totalSelected = Object.keys(values).reduce((sum, key) => values[key] + sum, 0)
          const disableIncrease = totalSelected >= promotionQuantity
          return (
            <Modal.FlexContainer>
              <Modal.Header>
                <PrevButton onClick={onPrevButtonClick} />
                <H4 normalised bold>{t('Choose _items_ item(s)', { items: promotionQuantity })}</H4>
                <CloseButton onClick={onCloseButtonClick} />
              </Modal.Header>
              <Modal.Body>
                <Modal.Section>
                  {(promotionItems || []).map((item, idx) => (
                    <React.Fragment key={item.id}>
                      <Div marginBottom={marginSizes.small}>
                        <P marginTop='none' bold>{item.name}</P>
                        <Flex justifyContent='space-between' alignItems='center'>
                          <Form.QuantitySelector
                            name={item.id}
                            disableIncrease={disableIncrease} />
                          <Flex>
                            <P normalised bold>{formatMoney(item.discountedPrice)}</P>
                            <LineThroughText normalised>{formatMoney(item.originalPrice)}</LineThroughText>
                          </Flex>
                        </Flex>
                      </Div>
                      {idx !== promotionItems.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </Modal.Section>
              </Modal.Body>
              <Modal.Footer>
                <Form.SubmitButton
                  fullWidth
                  disabled={isSubmitting || totalSelected === 0}>
                  {t('Confirm')}
                </Form.SubmitButton>
              </Modal.Footer>
            </Modal.FlexContainer>
          )
        }}
      </FormContext>
    </Form>
  )
})

PromotionItemForm.propTypes = {
  t: PropTypes.func, // Injected by Component
  onPromotionItemSubmit: PropTypes.func,
  onPrevButtonClick: PropTypes.func,
  onCloseButtonClick: PropTypes.func,
  formatMoney: PropTypes.func,
  promotionItems: PropTypes.array,
  promotionQuantity: PropTypes.number
}

export default PromotionItemForm
